import React, {useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {TableAsociados} from "./components/Table";
import {ModalNuevoAsociado} from "./components/ModalNuevoAsociado";
import {ModalEditarAsociado} from "./components/ModalEditarAsociado";
import {Navigate} from "react-router";

export const AsociadoPage = () => {
    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);

    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }
    return (
        <>
            <div className="container-relative">
                {permisos.consultar ? <TableAsociados reload={reload} obtenerParametrosUser={editarUsuario} nuevoUsuario={crearnuevoUsuario}/> : <Navigate to="/home"/>}
                <ModalNuevoAsociado show={displayNewModal} hide={onHide}/>
                <ModalEditarAsociado show={displayeditModal} hide={onHideEdit} fields={fieldEdit} />
            </div>
        </>
    );
};


